import React from 'react';
import PropTypes from 'prop-types';
import toDangerousReactHtml from '../../../../../helper/to_dangerous_react_html';
import { CustomCheckbox } from '../../../../form/custom_checkbox';

function WheelAlignmentService(props) {
    return (
        <span className="fsf-services__tag tag tag--optional">
            {props.billable && <CustomCheckbox
                additionalContainerClasses={["tag__choose", "styled-checkbox--violet"]}
                disabled={!props.billable}
                id={`wheel-alignment-${props.wheelQuantity}-checkbox`}
                onChange={props.onChange}
                checked={props.checked}
            />}
            <label className="tag__label" htmlFor={`wheel-alignment-${props.wheelQuantity}-checkbox`}>
              <span className="simple-tag">
                  Wheel alignment
                  {' '}
                  <span style={{ display: 'inline-block' }}>
                      ({props.wheelQuantity} wheels)
                  </span>
              </span>
            </label>
            <span className="tag__price" dangerouslySetInnerHTML={toDangerousReactHtml(props.wheelAlignment)} />
        </span>
    );
}

WheelAlignmentService.propTypes = {
    billable: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default WheelAlignmentService;
